module.exports = __webpack_public_path__ + "static/bg05-81bbea9386a5f8f3939212d73846e539.webp";